export default {
    init() {
        $(document).on("click", "[data-disable_on_click]", function () {
            $(this).addClass("disabled");
        });
        $(document).on("ajaxComplete", function () {
            setTimeout(() => $("[data-disable_on_click]").removeClass("disabled"), 500);
        });
    },
};
